<template>
  <div>
    <transition-notes v-if="activeModule === 'transition-notes'" />
    <transition-charter v-if="activeModule === 'transition-charter'" />
    <transition-manual v-if="activeModule === 'transition-manual'" />
    <transition-team v-if="activeModule === 'transition-team'" />
    <transition-thanks v-if="activeModule === 'transition-thanks'" />
  </div>
</template>

<script>
export default {
  name: 'Wrapper',
  props: {
    activeModule: {
      type: String,
      required: true
    }
  },
  components: {
    'transition-notes': () => import('@/components/transition/docs/Notes.vue'),
    'transition-charter': () =>
      import('@/components/transition/docs/Charter.vue'),
    'transition-manual': () =>
      import('@/components/transition/docs/Manual.vue'),
    'transition-team': () => import('@/components/transition/docs/Team.vue'),
    'transition-thanks': () => import('@/components/transition/docs/Thanks.vue')
  }
}
</script>
